module.exports = __webpack_public_path__ + "img/bates-wordmark.4f1adbcf.svg";